import { ROUTES } from '.';

// Helper function to build parameterized routes
export const buildRoute = {
  createStory: (templateId: string) => ROUTES.CREATE_STORY(templateId),
  checkout: (storyId: string) => `${ROUTES.CHECKOUT}?storyId=${storyId}`,
};
